const SATURATION = 55; 
const LIGHTNESS = 78; 

const DEFAULT_HEX = "#CBD5E1"; 

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; 
  }
  return Math.abs(hash);
}

function hslToHex(h: number, s: number, l: number): string {
  s /= 100;
  l /= 100;

  const k = (n: number) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) =>
    l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

  const toHex = (n: number) =>
    Math.round(f(n) * 255)
      .toString(16)
      .padStart(2, "0");

  return `#${toHex(0)}${toHex(8)}${toHex(4)}`;
}

export function getDepartmentColor(department: string | undefined | null): string {
  const name = (department || "").trim().toLowerCase();

  if (!name) {
    return DEFAULT_HEX;
  }

  const hue = hashString(name) % 360;
  return hslToHex(hue, SATURATION, LIGHTNESS);
}